module.exports = __webpack_public_path__ + "img/maxima20.462bec6b.png";